import { useQuery } from "@apollo/client";
import { Alert, useTheme } from "@mui/material";
import { gql } from "generated-graphql";
import {
  GetReportDetailsQuery,
  TierIiReportStep,
} from "generated-graphql/graphql";
import { useReport } from "routes/Customer/Chemicals/Report/useReport";

export const RFC_COUNTS_QUERY = gql(`
  query ReportingFacilityChemicalCounts($reportId: ID!) {
    reportingFacilityChemicalCounts(reportId: $reportId) {
      chemicalsToReportCount
      allChemicalsCount
    }
  }
`);

function useReportChemicals() {
  const { data: report } = useReport();
  const reportId = report?.tierIIReport?.id;
  const { data, loading } = useQuery(RFC_COUNTS_QUERY, {
    variables: reportId ? { reportId } : undefined,
    skip: !reportId,
    fetchPolicy: "cache-and-network",
  });

  return { data, loading };
}

export function checkChemicalSteps(report?: GetReportDetailsQuery) {
  const chemicalSteps: TierIiReportStep[] = [
    TierIiReportStep.Chemicals,
    TierIiReportStep.ChemicalSummary,
    TierIiReportStep.OtherChemicals,
    TierIiReportStep.Products,
  ];
  return report?.tierIIReport?.touchedSteps?.some((s) =>
    chemicalSteps.includes(s)
  );
}

export function useHasChemicalsToReport() {
  const { data, loading } = useReportChemicals();

  const hasChemicalsToReport =
    data?.reportingFacilityChemicalCounts?.chemicalsToReportCount != null
      ? data.reportingFacilityChemicalCounts.chemicalsToReportCount > 0
      : undefined;
  return { hasChemicalsToReport, loading };
}

export function ReportHasNoChemicalsAlert() {
  const theme = useTheme();
  const { data: report } = useReport();
  const hasStepsTouched = checkChemicalSteps(report);
  const { hasChemicalsToReport, loading } = useHasChemicalsToReport();

  if (loading || hasChemicalsToReport === true || !hasStepsTouched) {
    return <></>;
  }

  return (
    <Alert sx={{ mb: theme.spacing(2) }} severity="info">
      This facility has no chemicals over threshold and may not need to file a
      Tier II report.
    </Alert>
  );
}
